export default __webpack_public_path__ + "static/latitude-scam-alert-7-50cf31a7f377694dae2f48b2c269717f.webp";